import { useState } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Missed } from '@hhgtech/icons/other'
import { Box, BoxProps, ScrollArea } from '@mantine/core'
import { useIntl } from 'react-intl'

import ArrowDown from 'components/atoms/icons/ArrowDown'

import useStyles from './index.styles'

export type DisclaimerProps = {
  heading?: string
  description?: string
  maxHeight?: number
} & BoxProps

export const Disclaimer = ({
  heading,
  description,
  maxHeight,
  styles,
  className,
  classNames,
}: DisclaimerProps) => {
  const { formatMessage: f } = useIntl()
  const [opened, setOpened] = useState(false)
  const { cx, classes } = useStyles(
    { opened },
    {
      name: 'ClickableSingleBanner__Disclaimer',
      styles,
      classNames,
    },
  )

  return (
    <Box className={cx(classes.root, className)}>
      <Box className={classes.targetBtn} onClick={() => setOpened((v) => !v)}>
        <Missed size={18} className={classes.icon} />
        <Text size="s4" className={classes.targetText}>
          {heading || f({ id: 'clickableSingleBanner.disclaimer.heading' })}
        </Text>
        <ArrowDown size={18} className={classes.arrowIcon} />
      </Box>
      {maxHeight ? (
        <ScrollArea
          mah={maxHeight}
          scrollbarSize={4}
          classNames={{
            thumb: classes.scrollThumb,
          }}
        >
          <Text size="p5" className={classes.dropdown}>
            {description ||
              f({ id: 'clickableSingleBanner.disclaimer.description' })}
          </Text>
        </ScrollArea>
      ) : (
        <Text size="p5" className={classes.dropdown}>
          {description ||
            f({ id: 'clickableSingleBanner.disclaimer.description' })}
        </Text>
      )}
    </Box>
  )
}
